module.exports = __webpack_public_path__ + "img/4.665e6c4f.png";